import { Pipe, PipeTransform } from '@angular/core';
import { Employee } from '../../models/employee/employee';

@Pipe({
	name: 'filterEmployeeByName'
})
export class FilterEmployeeByNamePipe implements PipeTransform {
	transform(employee: Employee[], filter: string): Employee[] {
		if (
			!employee ||
			!filter ||
			employee === null ||
			filter === null ||
			filter === ''
		) {
			return employee;
		}

		return employee.filter((employee: Employee) => {
			if (employee.lastName && employee.firstName) {
				// TODO: add lastName too
				return employee.lastName.toLowerCase().includes(filter.toLowerCase()) || 
				employee.firstName.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
